import React from 'react';
import { View, Text } from 'native-base';
const MenuChannelsHeader = () => {
  return /*#__PURE__*/React.createElement(View, {
    w: '100%',
    ml: 8,
    mb: 3,
    mt: 5
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'md',
    fontWeight: 'bold'
  }, "Channels"));
};
export default MenuChannelsHeader;
//# sourceMappingURL=MenuChannelsHeader.js.map